module.exports = __webpack_public_path__ + "img/line-tab.1a0b04b5.svg";